module.exports = __webpack_public_path__ + "static/media/logo_fekete_hatterre_270.2e6f133b.png";